import { getVehicleProductYearFunction } from '@/common/queries/selections/vehicleProductYear/vehicleProductYearFunction';
import { queryOptions } from '@tanstack/react-query';

export const getVehicleProductYearOption = () =>
  queryOptions({
    queryKey: ['get_vehicle_product_year'],
    queryFn: () => getVehicleProductYearFunction(),
  });
